<script setup lang="ts">
import {
  ScenarioChatForm,
  mapToScenarioChatMessageInputs,
  useScenarioChatForm,
} from '@/components/organisms/ScenarioChatForm'
import type { ScenarioChatFormType } from '@/components/organisms/ScenarioChatForm'
import { useAlert } from '@/libs/alertPortal'
import {
  useCreateScenarioChatMutation,
  type ScenarioChatNewPageQuery,
} from './ScenarioChatNewPage.generated'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { onMounted, onUnmounted } from 'vue'

const props = defineProps<{
  query: ScenarioChatNewPageQuery
}>()

const alert = useAlert()
const router = useRouter()

const createScenarioChatMutation = useCreateScenarioChatMutation()

const handleCreate = async (scenarioChat: ScenarioChatFormType) => {
  await createScenarioChatMutation.mutate({
    input: {
      title: scenarioChat.title,
      messages: mapToScenarioChatMessageInputs(scenarioChat.messages),
    },
  })

  alert.success('シナリオを作成しました')
  // eslint-disable-next-line fp/no-mutating-methods
  router.push({ name: 'scenarioChatIndex' })
}

const form = useScenarioChatForm({
  initialScenarioChat: undefined,
  query: props.query,
  onSubmit: handleCreate,
})

onBeforeRouteLeave((_, __, next) => {
  // form.isSubmitting.value が true の場合は、onSubmit 時による成功時の画面遷移である
  // よってここでは form.isSubmitting.value が false の場合のみ、ユーザーに確認を求める
  if (form.isDirty.value && !form.isSubmitting.value) {
    if (confirm('編集内容を破棄して、このページを離れますか？')) {
      next(true)
    } else {
      next(false)
    }
    return
  }

  next(true)
})

const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  if (form.isDirty.value) {
    event.preventDefault()
  }
}

onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload)
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload)
})
</script>

<template>
  <ScenarioChatForm />
</template>
